import { confirmLinkJump } from "@/utils/public";
import GoLink from "@/static/golink.png";
import "./index.less";
import { useBlockNoSameDomainClick } from "@sui/chat-ui";

const titleNode = (
  <div className="jump-tips">
    {/* 您访问的链接即将离开 */}
    您访问的链接即将跳转当前网站，是否继续？
    {/* <img src={GoLink} width="160" alt="链接" />
    <br />
    是否继续？ */}
  </div>
);

function HyperLinkText(props) {
  const { file } = props;
  const handleClick = useBlockNoSameDomainClick()
  return (
    <a
      className="link_item"
      href={file.url}
      onClick={handleClick}
      target="_blank"
    >
      <span>{file.text}</span>
    </a>
  );
}

export default HyperLinkText;
